import { c as _c } from "react/compiler-runtime";
import { Collapsible, Container, classNames, Flex, FlexColumn, Markdown, TextHeading } from "@opensea/ui-kit";
import { PreviewActionBar } from "@/components/studio/page-editor/PreviewActionBar";

// Layout component props based on module fragment result

export function FaqModuleLayout(t0) {
  const $ = _c(15);
  const {
    title,
    questions,
    moduleIndex
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames("py-(--overview-vertical-padding)", "w-full items-center gap-3");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== moduleIndex) {
    t2 = moduleIndex !== undefined ? <PreviewActionBar moduleIndex={moduleIndex} /> : null;
    $[1] = moduleIndex;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = title || "FAQ";
  let t4;
  if ($[3] !== t3) {
    t4 = <Flex className="flex-1"><TextHeading size="lg">{t3}</TextHeading></Flex>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== questions) {
    t5 = questions?.map(_temp);
    $[5] = questions;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <FlexColumn className="w-full max-w-[640px] flex-1 gap-4">{t5}</FlexColumn>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t6) {
    t7 = <FlexColumn className="w-full flex-1 items-center gap-6">{t4}{t6}</FlexColumn>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t2 || $[13] !== t7) {
    t8 = <Container asChild={true}><FlexColumn className={t1}>{t2}{t7}</FlexColumn></Container>;
    $[12] = t2;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}
function _temp(question) {
  if (!question) {
    return null;
  }
  return <Flex className={classNames("w-full rounded-lg", "cursor-pointer bg-bg-additional-1", "[&>div]:w-full")} key={question.question}><Collapsible className="w-full px-6 py-7 text-left" content={<Markdown className="-mt-5 px-6 pb-6">{question.answer ?? ""}</Markdown>}><TextHeading size="xs">{question.question}</TextHeading></Collapsible></Flex>;
}